import { Container } from "../../components/layout/Container.jsx";
import { PageHero } from "../../components/shared/PageHero.jsx";
import { SEO } from "../../lib/seo.jsx";

const STEPS = [
  { title: "Research", description: "Discover designs that match your block and budget." },
  { title: "Strategic Planning", description: "Lock in inclusions, finance, and timeline." },
  { title: "Building", description: "Site cuts to handover, with a single project lead." },
  { title: "Aftercare", description: "Maintenance window + 6-, 12-month checks." },
];

export default function OurProcessPage() {
  const steps = STEPS;

  return (
    <>
      <SEO
        title="Our Process"
        description="Research, plan, build, support — the four-stage Shere-e-Punjab Homes process from first call to aftercare."
      />

      <PageHero
        eyebrow="How we work"
        title="Our build process"
        description="Four stages, one team, no handoffs. Here's exactly what to expect from the first call to handover and beyond."
      />

      <Container className="py-16 lg:py-20">
        <ol className="space-y-6">
          {steps.map((s, i) => (
            <li
              key={s.title || i}
              className="flex gap-6 rounded-2xl border border-border-subtle bg-bg-elevated p-6 lg:p-8"
            >
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-accent/15 font-display text-xl text-accent">
                {i + 1}
              </span>
              <div>
                <h2 className="font-display text-2xl text-text-primary lg:text-3xl">{s.title}</h2>
                {s.description && <p className="mt-2 text-text-secondary">{s.description}</p>}
              </div>
            </li>
          ))}
        </ol>
      </Container>
    </>
  );
}
